import Armont91 from '../../../BSD/Armont/Tipe 9/Tipe 9 (1).webp'
import Armont92 from '../../../BSD/Armont/Tipe 9/Tipe 9 (2).webp'
import Armont93 from '../../../BSD/Armont/Tipe 9/Tipe 9 (3).webp'
import Armont94 from '../../../BSD/Armont/Tipe 9/Tipe 9 (4).webp'



const Armont9images =[
Armont91,Armont92,Armont93,Armont94
]

export default Armont9images;